import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import {
  TdpSkillsTelemetryApi,
  UsageBucketResponse,
  TopSkillResponse,
  DeadSkillResponse,
  BySkillBucketResponse,
  UsageOverTimeParams,
  TopSkillsParams,
  DeadSkillsParams,
  BySkillParams,
} from './TdpSkillsTelemetryApi';

export class TdpSkillsTelemetryClient implements TdpSkillsTelemetryApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  private async getBaseUrl(): Promise<string> {
    return this.discoveryApi.getBaseUrl('tdp-skills-telemetry');
  }

  private buildQuery(params?: object): string {
    if (!params) return '';
    const entries = Object.entries(params).filter(([, v]) => v !== undefined);
    if (entries.length === 0) return '';
    return `?${new URLSearchParams(
      entries.map(([k, v]) => [k, String(v)]),
    ).toString()}`;
  }

  private async get<T>(path: string): Promise<T> {
    const baseUrl = await this.getBaseUrl();
    const response = await this.fetchApi.fetch(`${baseUrl}${path}`);
    if (!response.ok) {
      throw new Error(`Request failed: ${response.status} ${response.statusText}`);
    }
    return response.json();
  }

  async getUsageOverTime(params?: UsageOverTimeParams): Promise<UsageBucketResponse[]> {
    return this.get(`/usage-over-time${this.buildQuery(params)}`);
  }

  async getTopSkills(params?: TopSkillsParams): Promise<TopSkillResponse[]> {
    return this.get(`/top-skills${this.buildQuery(params)}`);
  }

  async getDeadSkills(params?: DeadSkillsParams): Promise<DeadSkillResponse[]> {
    return this.get(`/dead-skills${this.buildQuery(params)}`);
  }

  async getBySkill(skillName: string, params?: BySkillParams): Promise<BySkillBucketResponse[]> {
    return this.get(`/by-skill/${encodeURIComponent(skillName)}${this.buildQuery(params)}`);
  }
}
